<div class="header-actions">
  <!-- Notifications -->
<button mat-icon-button class="header-actions__btn" aria-label="Notifications" (click)="navigateToNotifications()">
  <mat-icon class="notification-icon"
            aria-hidden="false"
            [matBadge]="unreadCount()" 
            [matBadgeHidden]="unreadCount() === 0" 
            matBadgeColor="accent">
    notifications_none
  </mat-icon>
</button>


  <div class="header-actions__divider desktop-only"></div>

  <!-- Language Switcher -->
  <button mat-button
          (click)="toggleLanguage()"
          [matTooltip]="localeService.isHindi() ? 'Switch to English' : 'हिंदी में बदलें'"
          aria-label="Toggle language"
          class="header-actions__lang-btn desktop-only"
          id="header-language-toggle">
    <mat-icon class="lang-icon">language</mat-icon>
    <span>{{ isHindiActive ? 'HI' : 'EN' }}</span>
  </button>

  <!-- Profile Menu Trigger -->
  <div class="header-actions__profile-trigger"
       [matMenuTriggerFor]="profileMenu"
       role="button"
       tabindex="0"
       aria-label="User profile menu"
       id="header-profile-menu-trigger">
    <div class="header-actions__avatar">
      @if (profileService.photoUrl()) {
        <img [src]="profileService.photoUrl()" alt="" class="header-actions__avatar-img">
      } @else {
        {{ userInitials }}
      }
    </div>
    <span class="header-actions__profile-name">{{ userFullName }}</span>
    <mat-icon class="dropdown-icon">expand_more</mat-icon>
  </div>

  <mat-menu #profileMenu="matMenu" xPosition="before" class="header-actions__menu">
    <button mat-menu-item routerLink="/profile">
       <span>View Profile</span>
    </button>
 
    <button mat-menu-item (click)="logout()" class="header-actions__logout-btn" id="header-logout-btn">
       <span i18n="@@nav.logout">Logout</span>
    </button>

    <div class="menu-divider mobile-only" style="height: 1px; background-color: #e2e8f0; margin: 4px 0;"></div>

    <!-- Mobile Only Language Toggle -->
    <div mat-menu-item class="custom-menu-item mobile-only" (click)="$event.stopPropagation()">
      <div style="display: flex; justify-content: center; align-items: center; width: 100%; padding-top: 4px;">
        <div class="toggle-switch" (click)="toggleLanguage()" [class.toggled]="isHindiActive">
          <div class="toggle-knob">{{ isHindiActive ? 'HI' : 'EN' }}</div>
        </div>
      </div>
    </div>
  </mat-menu>
 
</div>
